var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM10.344 16.5L17.843 9L16.429 7.586L10.344 13.672L7.515 10.843L6.101 12.257L10.344 16.5Z","fill":"currentColor"}));
}

CheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
